import { NgModule } from '@angular/core';
import { FilterDropdownComponent } from './filter-dropdown.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UITKIconModule } from '@uhg-harmony/uitk-angular';

@NgModule({
  declarations: [FilterDropdownComponent],
  imports: [CommonModule, FormsModule, UITKIconModule],
  exports: [FilterDropdownComponent, UITKIconModule]
})
export class FilterDropdownModule {}
